// SPDX-FileCopyrightText: 2025 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import DatasetTag from 'components/common/DatasetTag';
import IconLabel from 'components/treactui-template/icons/IconLabel';
import React from 'react';
import { DatasetFilterType } from '../filter/filters-defaults';
import { IconCircle } from '@tls/treact-ui/icons';
interface Props {
  hasMask: boolean | undefined;
  isValidation: boolean | undefined;
  isQC: boolean;
  size?: string;
  iconLabelHeight?: string;
  circleStroke?: string;
  circleWidth?: string;
}

const LabeledIndicator = ({
  hasMask,
  isValidation,
  isQC,
  size = '24px',
  iconLabelHeight = '24px',
  circleStroke = '2px',
  circleWidth = '24px',
}: Readonly<Props>) => {
  if (hasMask) {
    if (isQC) {
      return (
        <DatasetTag
          dataset={isValidation ? DatasetFilterType.EvaluationSet : DatasetFilterType.TrainingSet}
          size={size}
        />
      );
    } else {
      return <IconLabel height={iconLabelHeight} />;
    }
  } else {
    return <IconCircle strokeWidth={circleStroke} viewBox='-2 -2 40 40' width={circleWidth} />;
  }
};

export default LabeledIndicator;
